import config from '../nyConfig'
const ApiReport = {
    "报告列表": new config({ url: '/assess/reportList', showSuccessMessage: false, useToken: true }),
    "量表测评记录": new config({ url: '/assess/listAssessInfo', showSuccessMessage: false, useToken: true }),
    "量表测评记录导出": new config({ url: '/assess/listAssessInfoExport', showSuccessMessage: true, useToken: true }),
}

export default ApiReport